import React, {useEffect, useState} from 'react'
import "./ProductModels.css"
import Color from '../Components/Colors/Color'
import { useStateContext } from '../Contexts/productsCardContext'


const Product = (props) => {
    const [backgroundColor, setBackgroundColor] = useState(Color.primaryBackground);
    const [textColor, setTextColor] = useState(Color.secondaryText);

    const {page} = useStateContext();

    useEffect(() => {
        console.log('comoestas')
        switch(page){
            case 'landing':
                setBackgroundColor(Color.primaryBackground);
                setTextColor(Color.secondaryText);
                break;
            case 'products':
                setBackgroundColor(Color.secondaryBackground);
                setTextColor(Color.thirdText);
                break;
            default:
                break;
        } 
    },[page]);
    

    return(
        <div className='card card-container' style={{backgroundColor: Color.primaryBackground, color: Color.secondaryText}}>
            <div className='card-header-container'>
                <h4 className='card-header'>
                    {props?.product.name}
                </h4>
            </div>
            
            <div className='card-image-container'>
                <img src={props?.product.imageLink} alt="product-image" className='card-img-top card-image' />
            </div>
            
            {/* <div className='card-body'>
                <h5 className='card-title'>
                    Packing
                </h5>
                <div className='card-list-container'>
                    <ul className='card-list'>
                        {props?.product.packing.map((pack) => (
                            <li className='card-item'>
                                <p className='card-text'>{pack.name}</p>
                            </li>
                        ))}
                    </ul>
                </div>
            </div> */}
        </div>
    )
}

export default Product